import { frontendURL } from '../../../helper/URLHelper';
import DataAssistantIndex from './Index.vue';
import DataAssistantReports from './Reports.vue';
import { DATA_ASSISTANT_MANAGE_PERMISSION } from '../../../constants/permissions.js';
import { DATA_ASSISTANT_ENABLED } from '../../../constants/dataAssistant';

// When the feature is disabled, every data-assistant URL redirects to the
// dashboard instead of rendering the (hidden) feature.
const buildRoute = ({ path, name, component, meta }) =>
  DATA_ASSISTANT_ENABLED
    ? { path, name, component, meta }
    : {
        path,
        name,
        meta,
        redirect: to => ({ name: 'home', params: to.params }),
      };

export const routes = [
  buildRoute({
    path: frontendURL('accounts/:accountId/data-assistant'),
    name: 'data_assistant_index',
    component: DataAssistantIndex,
    meta: {
      permissions: ['administrator', DATA_ASSISTANT_MANAGE_PERMISSION],
    },
  }),
  buildRoute({
    path: frontendURL('accounts/:accountId/data-assistant/reports'),
    name: 'data_assistant_reports_index',
    component: DataAssistantReports,
    meta: {
      permissions: ['administrator', 'agent', DATA_ASSISTANT_MANAGE_PERMISSION],
    },
  }),
  buildRoute({
    path: frontendURL('accounts/:accountId/data-assistant/reports/:reportId'),
    name: 'data_assistant_report_show',
    component: DataAssistantReports,
    meta: {
      permissions: ['administrator', 'agent', DATA_ASSISTANT_MANAGE_PERMISSION],
    },
  }),
  buildRoute({
    path: frontendURL('accounts/:accountId/data-assistant/:conversationId'),
    name: 'data_assistant_conversation',
    component: DataAssistantIndex,
    meta: {
      permissions: ['administrator', DATA_ASSISTANT_MANAGE_PERMISSION],
    },
  }),
];
